import { createElementVNode as _createElementVNode, toDisplayString as _toDisplayString, openBlock as _openBlock, createElementBlock as _createElementBlock, createCommentVNode as _createCommentVNode, normalizeClass as _normalizeClass } from "vue"

const _hoisted_1 = { id: "mobile-user-container" }
const _hoisted_2 = {
  key: 0,
  class: "mobile-menu-item email"
}
const _hoisted_3 = { key: 0 }
const _hoisted_4 = { key: 1 }

export function render(_ctx: any,_cache: any,$props: any,$setup: any,$data: any,$options: any) {
  return (_openBlock(), _createElementBlock("div", _hoisted_1, [
    _createElementVNode("div", {
      class: "mobile-user-icon",
      onClick: _cache[0] || (_cache[0] = 
//@ts-ignore
(...args) => (_ctx.toggleMobileMenu && _ctx.toggleMobileMenu(...args)))
    }, [...(_cache[2] || (_cache[2] = [
      _createElementVNode("i", { class: "bi bi-person-fill user-icon" }, null, -1)
    ]))]),
    _createElementVNode("div", {
      class: _normalizeClass(["mobile-menu", { 'mobile-menu-open': _ctx.isMobileMenuOpen }])
    }, [
      (_ctx.user.isAuthenticated)
        ? (_openBlock(), _createElementBlock("div", _hoisted_2, [
            (_ctx.user?.user?.profile?.email)
              ? (_openBlock(), _createElementBlock("span", _hoisted_3, _toDisplayString(_ctx.user.user.profile.email), 1))
              : (_openBlock(), _createElementBlock("span", _hoisted_4, "No email"))
          ]))
        : _createCommentVNode("", true),
      _createElementVNode("div", {
        class: "mobile-menu-item",
        onClick: _cache[1] || (_cache[1] = 
//@ts-ignore
(...args) => (_ctx.loginButton && _ctx.loginButton(...args)))
      }, _toDisplayString(_ctx.user.isAuthenticated ? 'Logout' : 'Login'), 1)
    ], 2)
  ]))
}